import { api } from './client.js';
const unwrap = (r) => r.data?.data;

export const supervisorApi = {
  // Admin — supervisor rules
  listRules: () => api.get('/admin/supervisor-rules').then(unwrap),
  createRule: (payload) => api.post('/admin/supervisor-rules', payload).then(unwrap),
  updateRule: (id, payload) => api.put(`/admin/supervisor-rules/${id}`, payload).then(unwrap),
  deleteRule: (id) => api.delete(`/admin/supervisor-rules/${id}`).then(unwrap),
  reorderRules: (updates) => api.put('/admin/supervisor-rules/reorder', { updates }).then(unwrap),
  previewResolution: (userId) => api.get(`/admin/supervisor-rules/preview/${userId}`).then(unwrap),

  // Admin — tags
  listTags: (params) => api.get('/admin/tags', { params }).then(unwrap),
  createTag: (payload) => api.post('/admin/tags', payload).then(unwrap),
  updateTag: (id, payload) => api.put(`/admin/tags/${id}`, payload).then(unwrap),
  deleteTag: (id) => api.delete(`/admin/tags/${id}`).then(unwrap),

  // Admin — per-user config
  getUserConfig: (userId) => api.get(`/admin/users/${userId}/supervisor-config`).then(unwrap),
  setUserSupervisor: (userId, payload) => api.post(`/admin/users/${userId}/supervisor`, payload).then(unwrap),
  setUserTags: (userId, tagIds) => api.post(`/admin/users/${userId}/tags`, { tagIds }).then(unwrap),
  getSupervisorChain: (userId) => api.get(`/admin/users/${userId}/supervisor-chain`).then(unwrap),

  // Org chart
  orgChart: () => api.get('/admin/org-chart').then(unwrap),

  // Self-service
  myChain: () => api.get('/me/supervisor').then(unwrap),
  myTags: () => api.get('/me/tags').then(unwrap),
};
